import React, { useState } from 'react'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from 'axios';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';


function CommonAlert({ setOpenCommonAlerts }) {

  const [openCommonAlert, setOpenCommonAlert] = useState(false);

  const [dashboardcount, setdashboardcount] = useState(1);

  const [apierrorMsg, setapierrorMsg] = useState();


  const [first, setfirst] = useState({ name: "", path: "", closeName: "Close" });

  const [domainNameUrl, setDomainNameUrl] = useState({ domain_name: '', domain_url: '' });

  const navigate = useNavigate();

  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;

  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {

        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          if (dashboardcount == 1) {
            setOpenCommonAlert(true);
            setdashboardcount(2)
            localStorage.setItem('need_domain_verification', true);
          }
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });


      if (datavalue?.data?.dor_domain_name && datavalue?.data?.dor_domain_url) {
        setDomainNameUrl({ ...domainNameUrl, domain_name: datavalue?.data?.dor_domain_name, domain_url: datavalue?.data?.dor_domain_url });
      }

      if (datavalue?.data) {
        if (datavalue?.data?.is_location_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Userdata" });
          setOpenCommonAlert(true);
          setOpenCommonAlerts(true);
          localStorage.setItem('need_domain_verification', true);
          return
        }
        if (datavalue?.data?.is_domain_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Impadddomain" });
          setOpenCommonAlert(true);
          setOpenCommonAlerts(true);
          localStorage.setItem('need_domain_verification', true);
          return
        }
        if (datavalue?.data?.is_domain_ownership_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Domainownership" });
          setOpenCommonAlert(true);
          setOpenCommonAlerts(true);
          localStorage.setItem('need_domain_verification', true);
          return
        }





      }

    } catch (err) {
      console.log(err);
    }
  };


  useEffect(() => {
    localStorage.setItem('need_domain_verification', false);
    GetuserDatavalue();
  }, [])


  return (
    <>
      {openCommonAlert &&
        <Dialog
          open={openCommonAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: {
              borderRadius: "18px !important",
              borderColor: "white !important",
              top: "10px !important"
            },
          }}
        >
          <DialogTitle className="keyword-dialog-header">Alert!!!!!</DialogTitle>
          <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }} >
            <DialogContentText id="alert-dialog-slide-description">
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px', lineHeight: '1px', width: "max-content" }}>
                <p>{"Please verify your domain ("}<a href={domainNameUrl.domain_url} title={`go to this link ${domainNameUrl.domain_url}`} >{domainNameUrl.domain_name}</a>{") to access these features"}</p>


              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button" sx={{ justifyContent: 'center' }}>
            <Button onClick={() => { navigate(first.path) }} >{first.name}</Button>
            <Button onClick={() => setOpenCommonAlert(false)} >{first.closeName}</Button>
          </DialogActions>
        </Dialog>
      }
    </>
  )
}

export default CommonAlert;


export async function GetuserDatavalue (setOpenCommonAlerts, ApiToken, navigate) {

  try {
    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
      {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
    ).catch((error) => {
      if (error?.code == "ERR_NETWORK") {
        navigate('/errorpages')
      }
    });

    if (datavalue?.data) {
      if (datavalue?.data?.is_location_required === true || 
        datavalue?.data?.is_domain_required === true ||
        datavalue?.data?.is_domain_ownership_required === true) {
        setOpenCommonAlerts(true);
      } else {
        setOpenCommonAlerts(false);
      }
    }

  } catch (err) {
    console.log(err);
  }
};